import {LoopReducer} from 'redux-loop'

import {Actions} from '../actions'
import * as toastActions from '../actions/toast'

import {Toast} from '../types'

export type ToastState = {
  toasts: Toast[]
}

const initialState: ToastState = {
  toasts: [],
}

const showToast = (state: ToastState, action: toastActions.ShowToastAction): ToastState => {
  if (state.toasts.find(toast => toast.id === action.payload.id)) {
    return {
      toasts: state.toasts.map(toast => {
        if (toast.id === action.payload.id) {
          return {
            ...toast,
            ...action.payload,
          }
        }

        return toast
      }),
    }
  }

  return {
    toasts: [action.payload, ...state.toasts],
  }
}

const hideToast = (state: ToastState, action: toastActions.HideToastAction): ToastState => ({
  toasts: state.toasts.filter(toast => toast.id !== action.payload.id),
})

const hideAllToasts = (): ToastState => ({...initialState})

const reducer: LoopReducer<ToastState, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOAST.SHOW':
      return showToast(state, action)
    case 'TOAST.HIDE':
      return hideToast(state, action)
    case 'TOAST.HIDE_ALL':
      return hideAllToasts()
    default:
      return state
  }
}

export default reducer
